var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { provideIntlService, registerForIntl } from '@progress/kendo-react-intl';
/**
 * @hidden
 */
var DateMarker = /** @class */ (function (_super) {
    __extends(DateMarker, _super);
    function DateMarker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateMarker.prototype.render = function () {
        var item = this.props.item;
        return React.createElement("div", { className: "k-timestamp" }, provideIntlService(this).formatDate(item.timestamp, 'D'));
    };
    return DateMarker;
}(React.Component));
export default DateMarker;
registerForIntl(DateMarker);
//# sourceMappingURL=DateMarker.js.map